import {
  getDocs,
  doc,
  getDoc,
  collection,
  query,
  setDoc,
} from "firebase/firestore";
import { db } from "config/firebase";

export const getMainContent = async () => {
  const q = query(collection(db, "main"));
  const querySnapshot = await getDocs(q);

  const mainContent = await Promise.all(
    querySnapshot.docs.map(async (docSnap) => {
      const data = docSnap.data();

      if (data.content && Array.isArray(data.content)) {
        const contentWithResolvedRefs = await Promise.all(
          data.content.map(async (item) => {
            if (item) {
              const itemDoc = await getDoc(item);
              return itemDoc.exists()
                ? { ...itemDoc.data(), id: itemDoc.id }
                : null;
            }
            return item;
          }),
        );

        return {
          ...data,
          id: docSnap.id,
          content: contentWithResolvedRefs.filter(Boolean),
        };
      }

      return { ...data, id: docSnap.id };
    }),
  );
  return mainContent;
};

export const updateMainContent = async (id, data) => {
  try {
    const updatedContent = data.content.map((item) => doc(db, id, item.id));
    const updatedData = { ...data, content: updatedContent };
    await setDoc(doc(db, "main", id), updatedData, { merge: true });
    return true;
  } catch (e) {
    console.error(`Error while updating main content: ${e}`);
    return false;
  }
};
